<template>
  <footer class="footer">
    <div class="footer-icons">
      <span><img src="https://cdn-icons-png.flaticon.com/512/597/597177.png" alt="Phone" width="24" /> +351 912 345 678</span>
      <span><img src="https://cdn-icons-png.flaticon.com/512/732/732200.png" alt="Email" width="24" /> karate@email.com</span>
      <span><img src="https://cdn-icons-png.flaticon.com/512/684/684908.png" alt="Map" width="24" /> Rua Principal, 123, Lisboa</span>
      <a href="https://web.facebook.com/KARATEANAM" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" width="24" /></a>
      <a href="https://www.instagram.com/anamkarate/" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/733/733558.png" alt="Instagram" width="24" /></a>
    </div>
    <ContactForm v-if="!hideForm" />
  </footer>
</template>

<script>
import ContactForm from './ContactForm.vue';
export default {
  name: 'Footer',
  components: { ContactForm },
  props: {
    hideForm: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  background: #222;
  color: #fff;
  padding: 2rem 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer-icons {
  display: flex;
  gap: 2rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.footer-icons span, .footer-icons a {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #fff;
  text-decoration: none;
}
.footer-icons a:hover {
  color: #e53935;
}

@media (max-width: 768px) {
  .footer-icons {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>

